import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-common-delete-dialog",
  templateUrl: "./common-delete-dialog.component.html",
  styleUrls: ["./common-delete-dialog.component.scss"],
  standalone: false
})
export class CommonDeleteDialogComponent {
  /** ダイアログの maxHeight のデフォルト値。 */
  public static readonly defaultDiaMaxHeight: string = "800px";
  /** ダイアログの width のデフォルト値。 */
  public static readonly defaultDialogWidth: string = "600px";
  /** ダイアログの minWidth のデフォルト値。 */
  public static readonly defaultDialogMinWidth: string = "400px";

  public message = "commonDeleteDialog.message";

  constructor(
    public dialogRef: MatDialogRef<CommonDeleteDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public data: { target: string; deleteNames: string[]; message?: string }
  ) {
    if (data.hasOwnProperty("message")) {
      this.message = data.message;
    }
  }

  delete() {
    this.dialogRef.close(true);
  }
}
